<template>
	<ul class="header-nav__social">
		<template v-for="button in socialButtons">
			<li>
				<a v-bind="{href: button[1]}"><i v-bind="{class: button[2]}" aria-hidden="true"></i></a>
			</li>
		</template>
	</ul>
</template>

<script>
	// import params object
	import {params as SiteParams} from '../../params';

	// export
	export default {
		name: 'SocialButtons',
		data: function () {
			return {
				socialButtons: SiteParams['socialButtons']
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/socialButtons/Buttons.vue